const width = window.innerWidth > 0 ? window.innerWidth : screen.width;
const height = window.innerHeight > 0 ? window.innerHeight : screen.height;
export const isMobile =
  /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ||
  width < 480 ||
  height < 480;
